import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

const EditWorkflowDetailsDialog = ({
  isOpen,
  onOpenChange,
  workflowName,
  setWorkflowName,
  workflowDescription,
  setWorkflowDescription,
  onSave,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Workflow Details</DialogTitle>
        </DialogHeader>
        <div className='space-y-4 py-4'>
          <div className='space-y-2'>
            <Label htmlFor='name'>Workflow Name</Label>
            <Input
              id='name'
              value={workflowName}
              onChange={(e) => setWorkflowName(e.target.value)}
              placeholder='Enter workflow name'
            />
          </div>
          <div className='space-y-2'>
            <Label htmlFor='description'>Description</Label>
            <Textarea
              id='description'
              value={workflowDescription}
              onChange={(e) => setWorkflowDescription(e.target.value)}
              placeholder='Enter workflow description'
            />
          </div>
          <div className='flex justify-end gap-2'>
            <Button variant='outline' onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button onClick={onSave}>Save Changes</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditWorkflowDetailsDialog;
